import { ArrowClockwise } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { StatusScreen } from '@/components/StatusScreen';

export type LoadErrorProps = {
  // Override the default copy when a page wants something specific.
  title?: string | undefined;
  body?: string | undefined;
  // Retry handler — typically a react-query refetch. When omitted the
  // button falls back to a full page reload (the old "Uppdatera" behaviour).
  onRetry?: (() => void) | undefined;
  className?: string | undefined;
};

// LoadError is the on-brand stand-in for the old bare red
// "Couldn't load. Refresh to try again." line. A failed fetch is almost
// always a transient connection issue, so the single action just tries
// again — refetching in place when the caller wires onRetry, otherwise
// reloading.
export function LoadError({ title, body, onRetry, className }: LoadErrorProps) {
  const { t } = useTranslation('common');

  return (
    <StatusScreen
      title={title ?? t('errors.loadFailed.title')}
      body={body ?? t('errors.loadFailed.body')}
      className={className}
      actions={[
        {
          label: t('errors.loadFailed.retry'),
          onClick: onRetry ?? (() => window.location.reload()),
          icon: <ArrowClockwise />,
        },
      ]}
    />
  );
}
